import { createModel } from '@rematch/core'
import { RootModel } from '@stores'

import { paymentGatewayClient } from '../../api/clients/payment-gateway-client'
import { TPaymentGatewayResponse } from '../../api/types/TPaymentGatewayResponse'
import {
  TPaymentGateway,
  TPaymentGatewayState,
} from '../types/TPaymentGatewayState'

export const paymentGateways = createModel<RootModel>()({
  state: {} as TPaymentGatewayState,
  reducers: {
    set(state, payload: TPaymentGatewayState) {
      return { ...state, ...payload }
    },
  },
  effects: (dispatch) => ({
    init(payload: TPaymentGatewayResponse[]) {
      dispatch.paymentGateways.set({
        paymentGateways: payload.map((v) => ({ ...v } as TPaymentGateway)),
      })
    },
    async fetchPaymentGateways(applicationUuid: string) {
      const paymentGateways = await paymentGatewayClient.getGateways(
        applicationUuid,
      )
      dispatch.paymentGateways.set({ paymentGateways })
    },
  }),
})
